import { useTranslation } from "react-i18next";
import { Field } from "../../components/neu/Field";
import { BranchChips } from "../../components/neu/BranchChips";

// بيانات التوظيف التي يحددها المدير/الموارد البشرية لحظة الموافقة.
// للموظف: الفرع موروث من الدعوة ويُعرض للقراءة فقط (لا يُختار مرة أخرى).
export const ApprovalFields = ({ form, setField, branches, toggleBranch, single }) => {
  const { t } = useTranslation();
  const names = (form.branch_ids || [])
    .map((id) => branches.find((b) => b.id === id)?.name)
    .filter(Boolean)
    .join("، ");
  return (
    <div className="mt-4 grid gap-4 sm:grid-cols-2">
      <div className="sm:col-span-2">
        <p className="label-xs mb-2">{single ? t("invites.branchOne") : t("employees.branches")}</p>
        {single ? (
          <div className="rounded-2xl px-4 py-3 text-sm font-semibold text-primary shadow-neu-in" data-testid="approve-branch-fixed">
            {names || t("requests.branchFromInvite")}
          </div>
        ) : (
          <BranchChips branches={branches} selected={form.branch_ids} onToggle={toggleBranch} prefix="approve-branch" />
        )}
      </div>
      <Field
        label={t("employees.jobTitle")}
        testId="approve-job-title"
        value={form.job_title}
        onChange={(v) => setField("job_title", v)}
      />
      <Field
        label={t("employees.salary")}
        testId="approve-salary"
        type="number"
        value={form.basic_salary}
        onChange={(v) => setField("basic_salary", v)}
      />
    </div>
  );
};
